<span
  class="inline-flex min-w-[88px] items-center justify-center rounded-full px-3 py-1 text-sm font-medium"
  [ngClass]="cssClass"
>
  {{ label }}
</span>
